import { Box } from "@material-ui/core";
import React from "react";

const SectionDivider = (props) => {
  const styles = {
    container: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent:
        props.position === "left"
          ? "flex-start"
          : props.position === "right"
          ? "flex-end"
          : "center",
    },
    divider: {
      width: 50,
      height: 2,
    },
  };
  return (
    <div style={{ ...styles.container, ...props.style }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {props.position === "center" && (
          <div
            style={{
              width: 25,
              height: 2,
              backgroundColor: "black",
              opacity: 0.2,
            }}
          />
        )}
        {props.position === "right" && (
          <div
            style={{
              width: 50,
              height: 2,
              backgroundColor: "black",
              opacity: 0.2,
            }}
          />
        )}
        <Box style={styles.divider} bgcolor="primary.main" />
        {props.position === "center" && (
          <div
            style={{
              width: 25,
              height: 2,
              backgroundColor: "black",
              opacity: 0.2,
            }}
          />
        )}
        {props.position === "left" && (
          <div
            style={{
              width: 50,
              height: 2,
              backgroundColor: "black",
              opacity: 0.2,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SectionDivider;
